import { ViewTableUtils, type ViewTableColumnsLayoutType } from 'app/main/components/page-layouts';

const DemsLogsColumn: ViewTableColumnsLayoutType = ({ t, updateRefresh }) => [
	{
		field: 'lgty_title',
		headerName: t('LOGS_COLUMN_TYPE'),
		minWidth: 150,
		flex: 1,
		renderCell: ({ value, row }) => ViewTableUtils.renderSquareChip({ value, backgroundColor: row.lgty_color }),
		sortable: false
	},
	{
		field: 'logs_payload',
		headerName: t('LOGS_COLUMN_ITEM_PAYLOAD'),
		minWidth: 650,
		flex: 1,
		sortable: false,
		hideable: true
	},
	{
		field: 'user_title',
		headerName: t('LOGS_COLUMN_USER'),
		minWidth: 175,
		flex: 2,
		renderCell: ({ value, row }) =>
			ViewTableUtils.renderCellWithTooltip({ value, to: { module: 'users', uid: row.logs_user_uid } }),
		sortable: false
	},
	{
		field: 'logs_date',
		headerName: t('LOGS_COLUMN_DATE'),
		minWidth: 175,
		renderCell: ({ value }) =>
			ViewTableUtils.renderDate({
				value,
				format: {
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
					hour: '2-digit',
					minute: '2-digit',
					second: '2-digit'
				}
			}),
		hideable: false
	}
];

export default DemsLogsColumn;
